const WarningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <path d="M18 36C8.075 36 0 27.925 0 18S8.075 0 18 0s18 8.075 18 18-8.075 18-18 18zm0-33.677C9.356 2.323 2.323 9.356 2.323 18c0 8.644 7.033 15.677 15.677 15.677 8.644 0 15.677-7.033 15.677-15.677 0-8.644-7.033-15.677-15.677-15.677z" />
    <path d="M15.602,27.429l0,-3.709l4.796,-0l-0,3.709l-4.796,-0Zm4.066,-6.373l-3.336,-0l-0.903,-12.485l5.142,0l-0.903,12.485Z" />
  </svg>
);

export default WarningIcon;
